var Schema = (function () {
  var instance;

  function createInstance() {
    return {
      ...gmdApplicationSchema(),
      ...gmdCitation(),
      ...gmdConstraints(),
      ...gmdContent(),
      ...gmdDataQuality(),
      ...gmdDistribution(),
      ...gmdExtent(),
      ...gmdFreeText(),
      ...gmdIdentification(),
      ...gmdMaintenance(),
      ...gmdMetadataEntity(),
      ...gmdMetadataExtension(),
      ...gmdPortrayalCatalogue(),
      ...gmdReferenceSystem(),
      ...gmdSpatialRepresentation(),
      ...srvServiceMetadata()
    }
  }

  return {
    getInstance: function () {
      if (!instance) {
        instance = createInstance();
      }
      return instance;
    }
  };
})();


const gmdApplicationSchema = _ => {
  return {
    'gmd:MD_ApplicationSchemaInformation_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:name': 'Nazwa',
        'gmd:schemaLanguage': 'schemaLanguage',
        'gmd:constraintLanguage': 'constraintLanguage',
        'gmd:schemaAscii': 'schemaAscii',
        'gmd:graphicsFile': 'graphicsFile',
        'gmd:softwareDevelopmentFile': 'softwareDevelopmentFile',
        'gmd:softwareDevelopmentFileFormat': 'softwareDevelopmentFileFormat'
      }
    },
    'gmd:MD_ApplicationSchemaInformation': {
      type: 'gmd:MD_ApplicationSchemaInformation_Type'
    }
  }
}

const gmdCitation = _ => {
  return {
    'gmd:CI_ResponsibleParty_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:individualName': 'individualName',
        'gmd:organisationName': 'Nazwa jednostki',
        'gmd:positionName': 'positionName',
        'gmd:contactInfo': 'Dane kontaktowe',
        'gmd:role': 'Rola'
      }
    },
    'gmd:CI_ResponsibleParty': {
      type: 'gmd:CI_ResponsibleParty_Type'
    },
    'gmd:CI_Citation_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:title': 'Tytuł',
        'gmd:alternateTitle': 'Alternatywny tytuł',
        'gmd:date': 'Data referencyjna',
        'gmd:edition': 'edition',
        'gmd:editionDate': 'editionDate',
        'gmd:identifier': 'Identyfikator zasobu',
        'gmd:citedResponsibleParty': 'citedResponsibleParty',
        'gmd:presentationForm': 'presentationForm',
        'gmd:series': 'series',
        'gmd:otherCitationDetails': 'otherCitationDetails',
        'gmd:collectiveTitle': 'collectiveTitle',
        'gmd:ISBN': 'ISBN',
        'gmd:ISSN': 'ISSN'
      }
    },
    'gmd:CI_Citation': {
      type: 'gmd:CI_Citation_Type'
    },
    'gmd:CI_Address_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:deliveryPoint': 'deliveryPoint',
        'gmd:city': 'Miejscowość',
        'gmd:administrativeArea': 'administrativeArea',
        'gmd:postalCode': 'Kod pocztowy',
        'gmd:country': 'Kraj',
        'gmd:electronicMailAddress': 'Adres poczty elektronicznej'
      }
    },
    'gmd:CI_Address': {
      type: 'gmd:CI_Address_Type'
    },
    'gmd:CI_OnlineResource_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:linkage': 'Adres zasobu sieciowego',
        'gmd:protocol': 'protocol',
        'gmd:applicationProfile': 'applicationProfile',
        'gmd:name': 'name',
        'gmd:description': 'description',
        'gmd:function': 'function'
      }
    },
    'gmd:CI_OnlineResource': {
      type: 'gmd:CI_OnlineResource_Type'
    },
    'gmd:CI_Contact_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:phone': 'Numer telefonu',
        'gmd:address': 'Adres',
        'gmd:onlineResource': 'Zasób sieciowy',
        'gmd:hoursOfService': 'hoursOfService',
        'gmd:contactInstructions': 'contactInstructions'
      }
    },
    'gmd:CI_Contact': {
      type: 'gmd:CI_Contact_Type'
    },
    'gmd:CI_Telephone_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:voice': null,
        'gmd:facsimile': null
      }
    },
    'gmd:CI_Telephone': {
      type: 'gmd:CI_Telephone_Type'
    },
    'gmd:CI_Date_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:date': 'Data',
        'gmd:dateType': 'Typ daty'
      }
    },
    'gmd:CI_Date': {
      type: 'gmd:CI_Date_Type'
    },
    'gmd:CI_Series_Type': {
      base: 'gco:AbstractObject_Type',
      felds: {
        'gmd:name': 'name',
        'gmd:issueIdentification': 'issueIdentification',
        'gmd:page': 'page'
      }
    },
    'gmd:CI_Series': {
      type: 'gmd:CI_Series_Type'
    }
  }
}

const gmdConstraints = _ => {
  return {
    'gmd:MD_Constraints_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:useLimitation': 'Ograniczenia użycia'
      }
    },
    'gmd:MD_Constraints': {
      type: 'gmd:MD_Constraints_Type'
    },
    'gmd:MD_LegalConstraints_Type': {
      base: 'gmd:MD_Constraints_Type',
      elements: {
        'gmd:accessConstraints': 'Prawne ograniczenia dostępu',
        'gmd:useConstraints': 'Prawne ograniczenia użycia',
        'gmd:otherConstraints': 'Inne ograniczenia prawne'
      }
    },
    'gmd:MD_LegalConstraints': {
      type: 'gmd:MD_LegalConstraints_Type'
    },
    'gmd:MD_SecurityConstraints_Type': {
      base: 'gmd:MD_Constraints_Type',
      elements: {
        'gmd:classification': 'Klasyfikacja ograniczeń bezpieczeństwa',
        'gmd:userNote': 'userNote',
        'gmd:classificationSystem': 'classificationSystem',
        'gmd:handlingDescription': 'handlingDescription'
      }
    },
    'gmd:MD_SecurityConstraints': {
      type: 'gmd:MD_SecurityConstraints_Type'
    }
  }
}

const gmdContent = _ => {
  return {
    'gmd:MD_FeatureCatalogueDescription_Type': {
      base: 'gmd:AbstractMD_ContentInformation_Type',
      elements: {
        'gmd:complianceCode': 'complianceCode',
        'gmd:language': 'Język zasobu',
        'gmd:includedWithDataset': 'includedWithDataset',
        'gmd:featureTypes': 'featureTypes',
        'gmd:featureCatalogueCitation': 'featureCatalogueCitation'
      }
    },
    'gmd:MD_FeatureCatalogueDescription': {
      type: 'gmd:MD_FeatureCatalogueDescription_Type'
    },
    'gmd:MD_CoverageDescription_Type': {
      base: 'gmd:AbstractMD_ContentInformation_Type',
      elements: {
        'gmd:attributeDescription': 'attributeDescription',
        'gmd:contentType': 'contentType',
        'gmd:dimension': 'dimension'
      }
    },
    'gmd:MD_CoverageDescription': {
      type: 'gmd:MD_CoverageDescription_Type'
    },
    'gmd:MD_ImageDescription_Type': {
      base: 'gmd:MD_CoverageDescription_Type',
      elements: {
        'gmd:illuminationElevationAngle': 'illuminationElevationAngle',
        'gmd:illuminationAzimuthAngle': 'illuminationAzimuthAngle',
        'gmd:imagingCondition': 'imagingCondition',
        'gmd:imageQualityCode': 'imageQualityCode',
        'gmd:cloudCoverPercentage': 'cloudCoverPercentage',
        'gmd:processingLevelCode': 'processingLevelCode',
        'gmd:compressionGenerationQuantity': 'compressionGenerationQuantity',
        'gmd:triangulationIndicator': 'triangulationIndicator',
        'gmd:radiometricCalibrationDataAvailability': 'radiometricCalibrationDataAvailability',
        'gmd:cameraCalibrationInformationAvailability': 'cameraCalibrationInformationAvailability',
        'gmd:filmDistortionInformationAvailability': 'filmDistortionInformationAvailability',
        'gmd:lensDistortionInformationAvailability': 'lensDistortionInformationAvailability'
      }
    },
    'gmd:MD_ImageDescription': {
      type: 'gmd:MD_ImageDescription_Type'
    },
    'gmd:AbstractMD_ContentInformation_Type': {
      base: 'gco:AbstractObject_Type'
    },
    'gmd:AbstractMD_ContentInformation': {
      type: 'gmd:AbstractMD_ContentInformation_Type'
    },
    'gmd:MD_RangeDimension_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:sequenceIdentifier': 'sequenceIdentifier',
        'gmd:descriptor': 'descriptor'
      }
    },
    'gmd:MD_RangeDimension': {
      type: 'gmd:MD_RangeDimension_Type'
    },
    'gmd:MD_Band_Type': {
      base: 'gmd:MD_RangeDimension_Type',
      elements: {
        'gmd:maxValue': 'maxValue',
        'gmd:minValue': 'minValue',
        'gmd:units': 'units',
        'gmd:peakResponse': 'peakResponse',
        'gmd:bitsPerValue': 'bitsPerValue',
        'gmd:toneGradation': 'toneGradation',
        'gmd:scaleFactor': 'scaleFactor',
        'gmd:offset': 'offset'
      }
    },
    'gmd:MD_Band': {
      type: 'gmd:MD_Band_Type'
    }
  }
}

const gmdDataQuality = _ => {
  return {
    'gmd:LI_ProcessStep_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:description': 'description',
        'gmd:rationale': 'rationale',
        'gmd:dateTime': 'dateTime',
        'gmd:processor': 'processor',
        'gmd:source': 'source'
      }
    },
    'gmd:LI_ProcessStep': {
      type: 'gmd:LI_ProcessStep_Type'
    },
    'gmd:LI_Source_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:description': 'description',
        'gmd:scaleDenominator': 'scaleDenominator',
        'gmd:sourceReferenceSystem': 'sourceReferenceSystem',
        'gmd:sourceCitation': 'sourceCitation',
        'gmd:sourceExtent': 'sourceExtent',
        'gmd:sourceStep': 'sourceStep'
      }
    },
    'gmd:LI_Source': {
      type: 'gmd:LI_Source_Type'
    },
    'gmd:LI_Lineage_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:statement': null,
        'gmd:processStep': 'processStep',
        'gmd:source': 'source'
      }
    },
    'gmd:LI_Lineage': {
      type: 'gmd:LI_Lineage_Type'
    },
    'gmd:DQ_ConformanceResult_Type': {
      base: 'gmd:AbstractDQ_Result_Type',
      elements: {
        'gmd:specification': 'Specyfikacja',
        'gmd:explanation': 'Wyjaśnienie',
        'gmd:pass': 'pass'
      }
    },
    'gmd:DQ_ConformanceResult': {
      type: 'gmd:DQ_ConformanceResult_Type'
    },
    'gmd:DQ_QuantitativeResult_Type': {
      base: 'gmd:AbstractDQ_Result_Type',
      elements: {
        'gmd:valueType': 'valueType',
        'gmd:valueUnit': 'valueUnit',
        'gmd:errorStatistic': 'errorStatistic',
        'gmd:value': 'value'
      }
    },
    'gmd:AbstractDQ_Element_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:nameOfMeasure': 'nameOfMeasure',
        'gmd:measureIdentification': 'measureIdentification',
        'gmd:measureDescription': 'measureDescription',
        'gmd:evaluationMethodType': 'evaluationMethodType',
        'gmd:evaluationMethodDescription': 'evaluationMethodDescription',
        'gmd:evaluationProcedure': 'evaluationProcedure',
        'gmd:dateTime': 'dateTime',
        'gmd:result': 'result'
      }
    },
    'gmd:AbstractDQ_Element': {
      type: 'gmd:AbstractDQ_Element_Type'
    },
    'gmd:DQ_DataQuality_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:scope': 'Zakres',
        'gmd:report': 'report',
        'gmd:lineage': 'Pochodzenie'
      }
    },
    'gmd:DQ_DataQuality': {
      type: 'gmd:DQ_DataQuality_Type'
    },
    'gmd:DQ_Scope_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:level': null,
        'gmd:extent': 'extent',
        'gmd:levelDescription': 'levelDescription'
      }
    },
    'gmd:DQ_Scope': {
      type: 'gmd:DQ_Scope_Type'
    }
  }
}

const gmdDistribution = _ => {
  return {
    'gmd:MD_Medium_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:name': 'name',
        'gmd:density': 'density',
        'gmd:densityUnits': 'densityUnits',
        'gmd:volumes': 'volumes',
        'gmd:mediumFormat': 'mediumFormat',
        'gmd:mediumNote': 'mediumNote'
      }
    },
    'gmd:MD_Medium': {
      type: 'gmd:MD_Medium_Type'
    },
    'gmd:MD_DigitalTransferOptions_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:unitsOfDistribution': 'unitsOfDistribution',
        'gmd:transferSize': 'transferSize',
        'gmd:onLine': null,
        'gmd:offLine': 'offLine'
      }
    },
    'gmd:MD_DigitalTransferOptions': {
      type: 'gmd:MD_DigitalTransferOptions_Type'
    },
    'gmd:MD_StandardOrderProcess_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:fees': 'fees',
        'gmd:plannedAvailableDateTime': 'plannedAvailableDateTime',
        'gmd:orderingInstructions': 'orderingInstructions',
        'gmd:turnaround': 'turnaround'
      }
    },
    'gmd:MD_StandardOrderProcess': {
      type: 'gmd:MD_StandardOrderProcess_Type'
    },
    'gmd:MD_Distributor_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:distributorContact': 'distributorContact',
        'gmd:distributionOrderProcess': 'distributionOrderProcess',
        'gmd:distributorFormat': 'distributorFormat',
        'gmd:distributorTransferOptions': 'distributorTransferOptions'
      }
    },
    'gmd:MD_Distributor': {
      type: 'gmd:MD_Distributor_Type'
    },
    'gmd:MD_Distribution_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:distributionFormat': 'Format dystrybucji',
        'gmd:distributor': 'distributor',
        'gmd:transferOptions': 'Opcje transferu'
      }
    },
    'gmd:MD_Distribution': {
      type: 'gmd:MD_Distribution_Type'
    },
    'gmd:MD_Format_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:name': 'Nazwa formatu',
        'gmd:version': 'Wersja formatu',
        'gmd:amendmentNumber': 'amendmentNumber',
        'gmd:specification': 'Specyfikacja',
        'gmd:fileDecompressionTechnique': 'fileDecompressionTechnique',
        'gmd:formatDistributor': 'formatDistributor'
      }
    },
    'gmd:MD_Format': {
      type: 'gmd:MD_Format_Type'
    }
  }
}

const gmdExtent = _ => {
  return {
    'gmd:EX_TemporalExtent_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:extent': 'extent'
      }
    },
    'gmd:EX_TemporalExtent': {
      type: 'gmd:EX_TemporalExtent_Type'
    },
    'gmd:EX_VerticalExtent_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:minimumValue': 'minimumValue',
        'gmd:maximumValue': 'maximumValue',
        'gmd:verticalCRS': 'verticalCRS'
      }
    },
    'gmd:EX_VerticalExtent': {
      type: 'gmd:EX_VerticalExtent_Type'
    },
    'gmd:EX_BoundingPolygon_Type': {
      base: 'gmd:AbstractEX_GeographicExtent_Type',
      elements: {
        'gmd:polygon': 'polygon'
      }
    },
    'gmd:EX_BoundingPolygon': {
      type: 'gmd:EX_BoundingPolygon_Type'
    },
    'gmd:EX_Extent_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:description': 'description',
        'gmd:geographicElement': null,
        'gmd:temporalElement': 'temporalElement',
        'gmd:verticalElement': 'verticalElement'
      }
    },
    'gmd:EX_Extent': {
      type: 'gmd:EX_Extent_Type'
    },
    'gmd:AbstractEX_GeographicExtent_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:extentTypeCode': 'extentTypeCode'
      }
    },
    'gmd:AbstractEX_GeographicExtent': {
      type: 'gmd:AbstractEX_GeographicExtent_Type'
    },
    'gmd:EX_GeographicBoundingBox_Type': {
      base: 'gmd:AbstractEX_GeographicExtent_Type',
      elements: {
        'gmd:westBoundLongitude': 'Południk granicy zachodniej (długość geograficzna)',
        'gmd:eastBoundLongitude': 'Południk granicy wschodniej (długość geograficzna)',
        'gmd:southBoundLatitude': 'Równoleżnik granicy południowej (szerokość geograficzna)',
        'gmd:northBoundLatitude': 'Równoleżnik granicy północnej (szerokość geograficzna)'
      }
    },
    'gmd:EX_GeographicBoundingBox': {
      type: 'gmd:EX_GeographicBoundingBox_Type'
    },
    'gmd:EX_SpatialTemporalExtent_Type': {
      base: 'gmd:EX_TemporalExtent_Type',
      elements: {
        'gmd:spatialExtent': 'spatialExtent'
      }
    },
    'gmd:EX_SpatialTemporalExtent': {
      type: 'gmd:EX_SpatialTemporalExtent_Type'
    },
    'gmd:EX_GeographicDescription_Type': {
      base: 'gmd:AbstractEX_GeographicExtent_Type',
      elements: {
        'gmd:geographicIdentifier': 'geographicIdentifier'
      }
    },
    'gmd:EX_GeographicDescription': {
      type: 'gmd:EX_GeographicDescription_Type'
    }
  }
}

const gmdFreeText = _ => {
  return {
    'gmd:PT_FreeText_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:textGroup': 'textGroup'
      }
    },
    'gmd:PT_FreeText': {
      type: 'gmd:PT_FreeText_Type'
    },
    'gmd:PT_Locale_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:languageCode': 'languageCode',
        'gmd:country': 'country',
        'gmd:characterEncoding': 'characterEncoding'
      }
    },
    'gmd:PT_Locale': {
      type: 'gmd:PT_Locale_Type'
    },
    'gmd:LocalisedCharacterString_Type': {
      base: 'xs:string',
      elements: {
        '@id': 'id',
        '@locale': 'locale'
      }
    },
    'gmd:LocalisedCharacterString': {
      type: 'gmd:LocalisedCharacterString_Type'
    },
    'gmd:PT_LocaleContainer_Type': {
      elements: {
        'gmd:description': 'description',
        'gmd:locale': 'locale',
        'gmd:date': 'date',
        'gmd:responsibleParty': 'responsibleParty',
        'gmd:localisedString': 'localisedString'
      }
    },
    'gmd:PT_LocaleContainer': {
      type: 'gmd:PT_LocaleContainer_Type'
    }
  }
}

const gmdIdentification = _ => {
  return {
    'gmd:AbstractMD_Identification_Type': {
      base: 'gco:AbstractObject_Typ',
      elements: {
        'gmd:citation': 'Przytoczenie',
        'gmd:abstract': 'Streszczenie',
        'gmd:purpose': 'purpose',
        'gmd:credit': 'credit',
        'gmd:status': 'status',
        'gmd:pointOfContact': 'Jednostka odpowiedzialna za zasób (punkt kontaktowy)',
        'gmd:resourceMaintenance': 'resourceMaintenance',
        'gmd:graphicOverview': 'graphicOverview',
        'gmd:resourceFormat': 'resourceFormat',
        'gmd:descriptiveKeywords': 'descriptiveKeywords',
        'gmd:resourceSpecificUsage': 'resourceSpecificUsage',
        'gmd:resourceConstraints': 'Ograniczenia zasobów',
        'gmd:aggregationInfo': 'aggregationInfo'
      }
    },
    'gmd:AbstractMD_Identification': {
      type: 'gmd:AbstractMD_Identification_Type'
    },
    'gmd:MD_BrowseGraphic_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:fileName': 'fileName',
        'gmd:fileDescription': 'fileDescription',
        'gmd:fileType': 'fileType'
      }
    },
    'gmd:MD_BrowseGraphic': {
      type: 'gmd:MD_BrowseGraphic_Type'
    },
    'gmd:MD_DataIdentification_Type': {
      base: 'gmd:AbstractMD_Identification_Type',
      elements: {
        'gmd:spatialRepresentationType': 'Sposób reprezentacji geometrii',
        'gmd:spatialResolution': 'Rozdzielczość przestrzenna',
        'gmd:language': 'Język',
        'gmd:characterSet': 'characterSet',
        'gmd:topicCategory': 'Kategoria tematyczna',
        'gmd:environmentDescription': 'environmentDescription',
        'gmd:extent': 'Zasięg przestrzenny',
        'gmd:supplementalInformation': 'supplementalInformation'
      }
    },
    'gmd:MD_DataIdentification': {
      type: 'gmd:MD_DataIdentification_Type'
    },
    'gmd:MD_ServiceIdentification_Type': {
      base: 'gmd:AbstractMD_Identification_Type'
    },
    'gmd:MD_ServiceIdentification': {
      type: 'gmd:MD_ServiceIdentification_Type'
    },
    'gmd:MD_RepresentativeFraction_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:denominator': 'Mianownik'
      }
    },
    'gmd:MD_RepresentativeFraction': {
      type: 'gmd:MD_RepresentativeFraction_Type'
    },
    'gmd:MD_Usage_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:specificUsage': 'specificUsage',
        'gmd:usageDateTime': 'usageDateTime',
        'gmd:userDeterminedLimitations': 'userDeterminedLimitations',
        'gmd:userContactInfo': 'userContactInfo'
      }
    },
    'gmd:MD_Usage': {
      type: 'gmd:MD_Usage_Type'
    },
    'gmd:MD_Keywords_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:keyword': 'keyword',
        'gmd:type': 'type',
        'gmd:thesaurusName': 'thesaurusName'
      }
    },
    'gmd:MD_Keywords': {
      type: 'gmd:MD_Keywords_Type'
    },
    'gmd:MD_AggregateInformation_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:aggregateDataSetName': 'aggregateDataSetName',
        'gmd:aggregateDataSetIdentifier': 'aggregateDataSetIdentifier',
        'gmd:associationType': 'associationType',
        'gmd:initiativeType': 'initiativeType'
      }
    },
    'gmd:MD_AggregateInformation': {
      type: 'gmd:MD_AggregateInformation_Type'
    },
    'gmd:MD_Resolution_Type': {
      elements: {
        'gmd:equivalentScale': 'Skala równoważna',
        'gmd:distance': 'distance'
      }
    },
    'gmd:MD_Resolution': {
      type: 'gmd:MD_Resolution_Type'
    }
  }
}

const gmdMaintenance = _ => {
  return {
    'gmd:MD_MaintenanceInformation_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:maintenanceAndUpdateFrequency': 'maintenanceAndUpdateFrequency',
        'gmd:dateOfNextUpdate': 'dateOfNextUpdate',
        'gmd:userDefinedMaintenanceFrequency': 'userDefinedMaintenanceFrequency',
        'gmd:updateScope': 'updateScope',
        'gmd:updateScopeDescription': 'updateScopeDescription',
        'gmd:maintenanceNote': 'maintenanceNote',
        'gmd:contact': 'contact'
      }
    },
    'gmd:MD_MaintenanceInformation': {
      type: 'gmd:MD_MaintenanceInformation_Type'
    },
    'gmd:MD_ScopeDescription_Type': {
      elements: {
        'gmd:attributes': 'attributes',
        'gmd:features': 'features',
        'gmd:featureInstances': 'featureInstances',
        'gmd:attributeInstances': 'attributeInstances',
        'gmd:dataset': 'dataset',
        'gmd:other': 'other'
      }
    },
    'gmd:MD_ScopeDescription': {
      type: 'gmd:MD_ScopeDescription_Type'
    }
  }
}

const gmdMetadataEntity = _ => {
  return {
    'gmd:MD_Metadata_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:fileIdentifier': 'Identyfikator dokumentu metadanych',
        'gmd:language': 'Język metadanych',
        'gmd:characterSet': 'System kodowania',
        'gmd:parentIdentifier': 'Identyfikator rodzica',
        'gmd:hierarchyLevel': 'Typ zasobu',
        'gmd:hierarchyLevelName': 'hierarchyLevelName',
        'gmd:contact': 'Punkt kontaktowy metadanych',
        'gmd:dateStamp': 'Data metadanych',
        'gmd:metadataStandardName': 'Standard metadanych',
        'gmd:metadataStandardVersion': 'Wersja standardu metadanych',
        'gmd:dataSetURI': 'dataSetURI',
        'gmd:locale': 'locale',
        'gmd:spatialRepresentationInfo': 'spatialRepresentationInfo',
        'gmd:referenceSystemInfo': 'Układ odniesienia',
        'gmd:metadataExtensionInfo': 'metadataExtensionInfo',
        'gmd:identificationInfo': 'Identyfikacja zbioru danych przestrzennych',
        'gmd:contentInfo': 'contentInfo',
        'gmd:distributionInfo': 'Dystrybucja',
        'gmd:dataQualityInfo': 'Jakość',
        'gmd:portrayalCatalogueInfo': 'portrayalCatalogueInfo',
        'gmd:metadataConstraints': 'Ograniczenia',
        'gmd:applicationSchemaInfo': 'applicationSchemaInfo',
        'gmd:metadataMaintenance': 'metadataMaintenance',
        'gmd:series': 'series',
        'gmd:describes': 'describes',
        'gmd:propertyType': 'propertyType',
        'gmd:featureType': 'featureType',
        'gmd:featureAttribute': 'featureAttribute'
      }
    },
    'gmd:MD_Metadata': {
      type: 'gmd:MD_Metadata_Type'
    }
  }
}

const gmdMetadataExtension = _ => {
  return {
    'gmd:MD_ExtendedElementInformation_Type': {
      base: 'gco:AbstractObject_Typ',
      elements: {
        'gmd:name': 'name',
        'gmd:shortName': 'shortName',
        'gmd:domainCode': 'domainCode',
        'gmd:definition': 'definition',
        'gmd:obligation': 'obligation',
        'gmd:condition': 'condition',
        'gmd:dataType': 'dataType',
        'gmd:maximumOccurrence': 'maximumOccurrence',
        'gmd:domainValue': 'domainValue',
        'gmd:parentEntity': 'parentEntity',
        'gmd:rule': 'rule',
        'gmd:rationale': 'rationale',
        'gmd:source': 'source'
      }
    },
    'gmd:MD_ExtendedElementInformation': {
      type: 'gmd:MD_ExtendedElementInformation_Type'
    },
    'gmd:MD_MetadataExtensionInformation_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:extensionOnLineResource': 'extensionOnLineResource',
        'gmd:extendedElementInformation': 'extendedElementInformation'
      }
    },
    'gmd:MD_MetadataExtensionInformation': {
      type: 'gmd:MD_MetadataExtensionInformation_Type'
    }
  }
}

const gmdPortrayalCatalogue = _ => {
  return {
    'gmd:MD_PortrayalCatalogueReference_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:portrayalCatalogueCitation': 'portrayalCatalogueCitation'
      }
    },
    'gmd:MD_PortrayalCatalogueReference': {
      type: 'gmd:MD_PortrayalCatalogueReference_Type'
    }
  }
}

const gmdReferenceSystem = _ => {
  return {
    'gmd:RS_Identifier_Type': {
      base: 'gmd:MD_Identifier_Type',
      elements: {
        'gmd:codeSpace': 'Kod katalogu',
        'gmd:version': 'Wersja'
      }
    },
    'gmd:RS_Identifier': {
      type: 'gmd:RS_Identifier_Type'
    },
    'gmd:MD_ReferenceSystem_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:referenceSystemIdentifier': 'Identyfikator układu odniesienia'
      }
    },
    'gmd:MD_ReferenceSystem': {
      type: 'gmd:MD_ReferenceSystem_Type'
    },
    'gmd:MD_Identifier_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:authority': 'authority',
        'gmd:code': 'Kod'
      }
    },
    'gmd:MD_Identifier': {
      type: 'gmd:MD_Identifier_Type'
    },
    'gmd:AbstractRS_ReferenceSystem_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:name': 'name',
        'gmd:domainOfValidity': 'domainOfValidity'
      }
    },
    'gmd:AbstractRS_ReferenceSystem': {
      type: 'gmd:AbstractRS_ReferenceSystem_Type'
    }
  }
}

const gmdSpatialRepresentation = _ => {
  return {
    'gmd:MD_GridSpatialRepresentation_Type': {
      base: 'gmd:AbstractMD_SpatialRepresentation_Type',
      elements: {
        'gmd:numberOfDimensions': 'numberOfDimensions',
        'gmd:axisDimensionProperties': 'axisDimensionProperties',
        'gmd:cellGeometry': 'cellGeometry',
        'gmd:transformationParameterAvailability': 'transformationParameterAvailability'
      }
    },
    'gmd:MD_GridSpatialRepresentation': {
      type: 'gmd:MD_GridSpatialRepresentation_Type'
    },
    'gmd:MD_VectorSpatialRepresentation_Type': {
      base: 'gmd:AbstractMD_SpatialRepresentation_Type',
      elements: {
        'gmd:topologyLevel': 'topologyLevel',
        'gmd:geometricObjects': 'geometricObjects'
      }
    },
    'gmd:MD_VectorSpatialRepresentation': {
      type: 'gmd:MD_VectorSpatialRepresentation_Type'
    },
    'gmd:MD_Georeferenceable_Type': {
      base: 'gmd:MD_GridSpatialRepresentation_Type',
      elements: {
        'gmd:controlPointAvailability': 'controlPointAvailability',
        'gmd:orientationParameterAvailability': 'orientationParameterAvailability',
        'gmd:orientationParameterDescription': 'orientationParameterDescription',
        'gmd:georeferencedParameters': 'georeferencedParameters',
        'gmd:parameterCitation': 'parameterCitation'
      }
    },
    'gmd:MD_Georeferenceable': {
      type: 'gmd:MD_Georeferenceable_Type'
    },
    'gmd:MD_Dimension_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:dimensionName': 'dimensionName',
        'gmd:dimensionSize': 'dimensionSize',
        'gmd:resolution': 'resolution'
      }
    },
    'gmd:MD_Dimension': {
      type: 'gmd:MD_Dimension_Type'
    },
    'gmd:MD_Georectified_Type': {
      base: 'gmd:MD_GridSpatialRepresentation_Type',
      elements: {
        'gmd:checkPointAvailability': 'checkPointAvailability',
        'gmd:checkPointDescription': 'checkPointDescription',
        'gmd:cornerPoints': 'cornerPoints',
        'gmd:centerPoint': 'centerPoint',
        'gmd:pointInPixel': 'pointInPixel',
        'gmd:transformationDimensionDescription': 'transformationDimensionDescription',
        'gmd:transformationDimensionMapping': 'transformationDimensionMapping'
      }
    },
    'gmd:MD_Georectified': {
      type: 'gmd:MD_Georectified_Type'
    },
    'gmd:MD_GeometricObjects_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'gmd:geometricObjectType': 'geometricObjectType',
        'gmd:geometricObjectCount': 'geometricObjectCount'
      }
    },
    'gmd:MD_GeometricObjects': {
      type: 'gmd:MD_GeometricObjects_Type'
    }
  }
}

const srvServiceMetadata = _ => {
  return {
    'srv:SV_OperationMetadata_Type': {
      base: 'gco:AbstractObject_Type',
      elements: {
        'srv:operationName': 'operationName',
        'srv:DCP': 'DCP',
        'srv:operationDescription': 'operationDescription',
        'srv:invocationName': 'invocationName',
        'srv:parameters': 'parameters',
        'srv:connectPoint': 'connectPoint',
        'srv:dependsOn': 'dependsOn'
      }
    },
    'srv:SV_OperationMetadata': {
      type: 'srv:SV_OperationMetadata_Type'
    },
    'srv:SV_ServiceIdentification_Type': {
      base: 'gmd:AbstractMD_Identification_Type',
      elements: {
        'srv:serviceType': 'serviceType',
        'srv:serviceTypeVersion': 'serviceTypeVersion',
        'srv:accessProperties': 'accessProperties',
        'sv:restrictions': 'restrictions',
        'srv:keywords': 'keywords',
        'srv:extent': 'Zasięg przestrzenny',
        'srv:coupledResource': 'coupledResource',
        'srv:couplingType': 'couplingType',
        'srv:containsOperations': 'containsOperations',
        'srv:operatesOn': 'operatesOn'
      }
    },
    'srv:SV_ServiceIdentification': {
      type: 'srv:SV_ServiceIdentification_Type'
    }
  }
}

export default Schema;